import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容导航",
    links: [
      { to: "/", label: "首页" },
      { to: "/heji", label: "合集总览" },
      { to: "/heji?cat=kaogu", label: "考古旧瓜" },
      { to: "/heji?cat=mingchang", label: "名场面补档" },
    ],
  },
  {
    title: "专题分类",
    links: [
      { to: "/heji?cat=quannei", label: "圈内合集" },
      { to: "/heji?cat=remen", label: "实时热议" },
      { to: "/heji?sort=hot", label: "热度榜" },
      { to: "/heji?sort=new", label: "最新补档" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { to: "/about", label: "关于我们" },
      { to: "/about#principles", label: "内容原则" },
      { to: "/contact", label: "联系我们" },
      { to: "/contact", label: "话题推荐" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-20 bg-accent-950 text-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-background-50/10 text-background-50">
                <i className="ri-chat-smile-2-line text-2xl"></i>
              </span>
              <span className="font-display text-2xl tracking-wide">蝌蚪吃瓜</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-50/70">
              专注整理娱乐行业的公开话题，以合集、补档、考古为主要形态，把错过的瓜重新翻出来，历史名场面完整收录。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="mailto:hello@tadpolegua.com"
                rel="nofollow"
                aria-label="发送邮件"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-mail-line"></i>
              </a>
              <a
                href="mailto:hello@tadpolegua.com"
                rel="nofollow"
                aria-label="联系我们"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-customer-service-2-line"></i>
              </a>
              <a
                href="mailto:hello@tadpolegua.com"
                rel="nofollow"
                aria-label="订阅更新"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-rss-line"></i>
              </a>
            </div>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="text-sm font-medium text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-50/70 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-50/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 蝌蚪吃瓜 · 内容均为公开话题整理与阅读分享</p>
          <p>
            联系邮箱：hello@tadpolegua.com · 本站内容仅供阅读交流，不针对任何个人
          </p>
        </div>
      </div>
    </footer>
  );
}